<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container-fulid text-center overflow-hidden" style="width: 95%; margin: 0 auto;">
  <div class="row justify-content-center">
    <div class="col-8">
      <h1 class="lifedi-color">
        วิจัย
      </h1>
    </div>
  </div>
  <div class="row d-flex pb-4 justify-content-center">
    <input type="text" class="form-control search" placeholder="ค้นหาชื่อวิจัย, ผู้สร้างวิจัย, แบบทดสอบ"
      name="searchName" [(ngModel)]="search" (keyup)="searching()">
    <lifedi-btn lable="เพิ่มวิจัย" (click)="addResearch()" customStyle="position: absolute; right: 3%; margin-top: 0px; padding: 0 25px; background: #005C3D; color:
    #FFFFFF">
    </lifedi-btn>
  </div>

  <!-- not search -->
  <nz-table *ngIf="!isSearch" #groupingTable [nzData]="allResearch" nzBordered nzSize="large"
    class="table table-striped">
    <thead>
      <tr>
        <th class="text-center" [nzSortFn]="sortIdFn">รหัสวิจัย</th>
        <th class="text-center">ชื่อวิจัย</th>
        <th class="text-center">ผู้สร้างวิจัย</th>
        <th class="text-center">แบบทดสอบ</th>
        <th class="text-center">ระยะดำเนินโครงการ</th>
        <th class="text-center" [nzFilters]="filterViewStatus" [nzFilterFn]="viewStatusFilterFn">สถานะการมองเห็น</th>
        <th class="text-center">รายละเอียด</th>
        <th class="text-center">Export</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let research of groupingTable.data;">
        <td class="text-center">{{ research.RESEARCH_ID }}</td>
        <td class="text-center">{{ research.RESEARCH_NAME }}</td>
        <td class="text-center">{{ research.CREATE_NAME }}</td>
        <td class="text-left">
          <span *ngFor="let measure of research.MEASURES; let last = last">
            <span *ngIf="measure">-</span> {{ measure }}<span *ngIf="!last">,</span><br>
          </span>
        </td>
        <td *ngIf="research.ALWAYS_OPEN == 'true'" class="text-center">เปิดตลอด</td>
        <td *ngIf="research.ALWAYS_OPEN == 'false'" class="text-center">
          {{ research.RESEARCH_START | date }} - {{ research.RESEARCH_END | date}}
        </td>
        <td class="text-center">
          <mat-slide-toggle color="primary" [(ngModel)]="!research.IS_VIEW" [ngModelOptions]="{ standalone: true }"
            (change)="changeStatus($event, research)">
          </mat-slide-toggle>
        </td>

        <td class="text-center">
          <a (click)="viewDetail(research.RESEARCH_ID)" target="_blank">
            <img src="assets/other/file.png" alt="" width="20px">
          </a>
        </td>

        <td class="text-center">
          <a (click)="exportFile(research.RESEARCH_ID, research.RESEARCH_NAME)" style="cursor: pointer;">
            <img src="assets/document.png" style="width: 23px;">
          </a>
        </td>
      </tr>
    </tbody>
  </nz-table>


  <!-- search -->
  <nz-table *ngIf="isSearch" #groupingTable [nzData]="searchResearch" nzBordered nzSize="large"
    class="table table-striped">
    <thead>
      <tr>
        <th class="text-center" [nzSortFn]="sortIdFn">รหัสวิจัย</th>
        <th class="text-center">ชื่อวิจัย</th>
        <th class="text-center">ผู้สร้างวิจัย</th>
        <th class="text-center">แบบทดสอบ</th>
        <th class="text-center">ระยะดำเนินโครงการ</th>
        <th class="text-center" [nzFilters]="filterViewStatus" [nzFilterFn]="viewStatusFilterFn">สถานะการมองเห็น</th>
        <th class="text-center">รายละเอียด</th>
        <th class="text-center">Export</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let research of groupingTable.data">
        <td class="text-center">{{ research.RESEARCH_ID }}</td>
        <td class="text-center">{{ research.RESEARCH_NAME }}</td>
        <td class="text-center">{{ research.CREATE_NAME }}</td>
        <td class="text-left">
          <span *ngFor="let measure of research.MEASURES; let last = last">
            <span *ngIf="measure">-</span> {{ measure }}<span *ngIf="!last">,</span><br>
          </span>
        </td>
        <td *ngIf="research.ALWAYS_OPEN == 'true'" class="text-center">เปิดตลอด</td>
        <td *ngIf="research.ALWAYS_OPEN == 'false'" class="text-center">
          {{ research.RESEARCH_START | date }} - {{ research.RESEARCH_END | date}}
        </td>
        <td class="text-center">
          <mat-slide-toggle color="primary" [(ngModel)]="!research.IS_VIEW" [ngModelOptions]="{ standalone: true }"
            (change)="changeStatus($event, research)">
          </mat-slide-toggle>
        </td>

        <td class="text-center">
          <a (click)="viewDetail(research.RESEARCH_ID)" target="_blank">
            <img src="assets/other/file.png" alt="" width="20px">
          </a>
        </td>

        <td class="text-center">
          <a (click)="exportFile(research.RESEARCH_ID, research.RESEARCH_NAME)" style="cursor: pointer;">
            <img src="assets/document.png" style="width: 23px;">
          </a>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
